import { render } from "./UserCheckCreate.vue?vue&type=template&id=1c169dfe&scoped=true"
import script from "./UserCheckCreate.vue?vue&type=script&lang=js"
export * from "./UserCheckCreate.vue?vue&type=script&lang=js"

import "./UserCheckCreate.vue?vue&type=style&index=0&id=1c169dfe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c169dfe"]])

export default __exports__